import { render, staticRenderFns } from "./next_person.vue?vue&type=template&id=415a03c8&scoped=true&"
import script from "./next_person.vue?vue&type=script&lang=js&"
export * from "./next_person.vue?vue&type=script&lang=js&"
import style0 from "./next_person.vue?vue&type=style&index=0&id=415a03c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415a03c8",
  null
  
)

export default component.exports